import { ChangePricingPlanModal } from 'features/pricing/modals/ChangePricingPlanModal';
import { FormattedMessage } from 'react-intl';

const AccessExpiredModal = () => (
  <ChangePricingPlanModal
    headline={<FormattedMessage id="access.expired_head" values={{ br: <br /> }} />}
  />
);

export default AccessExpiredModal;
